<template>
    <div>
        <CFTitle title="3. Responsabil de proiect"></CFTitle>

        <div class="mt-5">
            <validation-observer #default="{ invalid }" ref="responsabilProiect">
                <span class="display-none">{{ invalid }}</span>
                <div class="flex justify-content-center mb-1 modify-res">
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 30%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Nume"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.first_name"
                                type="text"
                                :readonly="completed"
                                :state="errors.length > 0 ? false : null"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 27%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Prenume"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.last_name"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 25.6%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Funcție"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.position"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                readonly
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
                <div class="flex justify-content-center mb-1 modify-res">
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 30%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Telefon"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.phone"
                                type="text"
                                readonly
                                :state="errors.length > 0 ? false : null"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 27%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Fax"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.fax"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                readonly
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required|email"
                        style="width: 25.6%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Email"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.email"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                readonly
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
            </validation-observer>
        </div>
        <p class="info-text">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/compania-mea">Compania mea</router-link></p>


        <hr class="mt-5">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormInput, BFormGroup, BFormCheckbox } from "bootstrap-vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    require('@/helpers/validations/validations');
    export default {
        components: {
            CFTitle,
            BFormInput, BFormGroup, BFormCheckbox,
            ValidationProvider, ValidationObserver
        },
        props: {
            data: null,
            m3GrantApplication: null
        },
        data() {
            return {
                completed: false,
                form: {
                    first_name: '',
                    last_name: '',
                    position: '',
                    phone: '',
                    fax: '',
                    email: '',
                }
            }
        },
        computed: {
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            data: {
                handler: function() {
                    this.getFormData()
                },
                deep: true
            },
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Responsabil de proiect')) {
                        this.completed = true
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.getFormData()
            if(this.finantareProgress && this.finantareProgress.includes('Responsabil de proiect')) {
                this.completed = true
            }
        },
        methods: {
            getFormData() {
                if(this.m3GrantApplication && this.m3GrantApplication.responsabil_proiect){
                    this.form = this.m3GrantApplication.responsabil_proiect
                } else{
                    if(this.data && this.data.delegate) {
                        this.form.first_name = this.data.delegate.name.split(' ')[0]
                        this.form.last_name = this.data.delegate.name.split(' ').slice(1).join(' ')
                        this.form.position = this.data.delegate_type
                        this.form.phone = this.data.delegate.phone
                        this.form.fax = this.data.delegate.fax ? this.data.delegate.fax : '-'
                        this.form.email = this.data.delegate.email
                    }
                }
            },
            sendForm() {
                this.$refs.responsabilProiect.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.$emit('responsabilProiect', this.form)
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {responsabil_proiect: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Responsabil de proiect')
                                })
                        }
                        else{
                            this.$store.dispatch('finantare/removeFromProgress', 'Responsabil de proiect')
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 47%;
}
.second-input{
    width: 44%;
}
</style>
